import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import type { AnyRoute } from "@tanstack/react-router";

export const createMonitorRoutes = (parent: AnyRoute) => [
  createRoute({
    getParentRoute: () => parent,
    path: "/monitor/system_log",
    component: lazyRouteComponent(() => import("pages/monitor/system_log")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/monitor/action_log",
    component: lazyRouteComponent(() => import("pages/monitor/action_log")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/monitor/machine_log",
    component: lazyRouteComponent(() => import("pages/monitor/machine_log")),
  }),
];
